var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{class:['sa-sidebar', ("sidebar-" + _vm.type + "-" + _vm.variant), _vm.elevationClass],attrs:{"id":"sa-sidebar-id"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }